import { Radio } from 'antd';
import classNames from 'classnames';

import ErrorMessage from '~/shared/components/form-fields/error-message/error-message';

import './radio-group-field.scss';

type RadioGroupFieldType = {
  isRow: boolean;
  input: Record<string, unknown>;
  meta: {
    touched: boolean;
    error: string;
  };
  radios: { label: string; value: string }[];
};

const RadioGroupField = (props: RadioGroupFieldType) => {
  const { input, meta, onChange, config } = props;

  return (
    <div
      className={classNames('radio-group-field', {
        'radio-group-field--as-row': config?.isRow,
      })}
    >
      <Radio.Group {...input} value={props?.value} onChange={onChange}>
        {config?.radios?.map((radio) => (
          <Radio value={radio.value} key={radio.label}>
            {radio.label}
          </Radio>
        ))}
      </Radio.Group>
      {meta?.touched && meta?.error && <ErrorMessage error={meta?.error} />}
    </div>
  );
};

export default RadioGroupField;
